import { faUser } from '@fortawesome/pro-light-svg-icons/faUser'
import CustomButton from '@space-core/components/customButton'
import { VariationTypes } from '@space-core/components/customButton/types'
import type { DropdownItemProps } from '@space-core/components/dropdown/types'
import DropdownPublic from '@space-core/components/dropdown/user'

import type { ThemeMode } from '@space-core/styles/themes/enum'

import type { ApplicationLanguageType } from '@space-shell/common/components/customLanguage/constants'
import { useDataHubEvents } from '@space-shell/common/hooks/useDataHubEvents'

import { useTranslation } from 'react-i18next'

import HeaderOptions from './headerOptions'

type UnauthenticatedHeaderProps = {
  isMobile: boolean
  publicItems: DropdownItemProps[]
  theme: ThemeMode
  switchTheme: () => void
  applicationLanguage: string
  handleLanguageChange: (lang: ApplicationLanguageType) => void
  handleRedirectToSignIn: (eventOption?: string) => void
}

export function UnauthenticatedHeader({
  isMobile,
  publicItems,
  theme,
  switchTheme,
  applicationLanguage,
  handleLanguageChange,
  handleRedirectToSignIn
}: UnauthenticatedHeaderProps) {
  const { sendDataHubEvent } = useDataHubEvents()
  const { t } = useTranslation()

  return (
    <div slot='actions-end' className='_d-flex _w-full _justify-content-end'>
      <div className='_d-flex _align-items-center'>
        {!isMobile && (
          <>
            <CustomButton
              size='sm'
              variation={VariationTypes.SECONDARY}
              className='_mr-2'
              onClick={publicItems[0].handleClick}
              data-test='button-end'>
              {publicItems[0].label}
            </CustomButton>
            <CustomButton size='sm' onClick={publicItems[1].handleClick} data-test='button-start'>
              {publicItems[1].label}
            </CustomButton>
          </>
        )}

        <div className='_ml-4'>
          {isMobile ? (
            <CustomButton
              size='sm'
              onClick={() => handleRedirectToSignIn('click_login')}
              data-test='button-start'>
              {t('general.signin')}
            </CustomButton>
          ) : (
            <DropdownPublic
              icon={faUser}
              theme={theme}
              isLogged={false}
              dropdownItems={publicItems}
              sendDataHubEvent={sendDataHubEvent}>
              <HeaderOptions
                switchTheme={switchTheme}
                applicationLanguage={applicationLanguage}
                handleLanguageChange={handleLanguageChange}
                theme={theme}
                isAuthenticated={false}
                isGamificationEnabled={false}
              />
            </DropdownPublic>
          )}
        </div>
      </div>
    </div>
  )
}
